import {useParams} from "react-router-dom";
import '../../media/styles/styles.css';
import PromotionTable from "./PromotionTable";
import Carousel from "../Carousel/Carousel";
import {useFetch} from "../../helpers/APIHelper";
import Loading from "../Loading";
import Error from "../Error";

function PromotionDetails() {
    const {promotionname} = useParams();

    let ref = promotionname.toUpperCase();

    const {data, loading, error} = useFetch({endpoint: `/promotions/${ref}`});

    if (loading) {
        return <Loading/>;
    }

    if (error) {
        return <Error error={error}/>;
    }

    const promotion = data.data;

    return (
        <>
            <div className="container mx-auto md:w-5/6 flex justify-center flex-col">
                <Carousel images={promotion.attachments.filter((attachment) => (attachment.type === "image"))} details={true}/>
                <h1 className="text-2xl mt-4 text-center px-4 md:px-0">
                    {promotion.subtitle}
                </h1>
                <div className="flex self-center flex-col md:w-4/6 text-sm mt-2 styled-ul px-4 md:px-0"
                     dangerouslySetInnerHTML={{__html: promotion.description}}></div>
            </div>
            <div className="container mx-auto md:w-4/6 text-sm">
                <h2 className="text-2xl font-bold mt-6 pb-4 px-4 md:px-0">Biens de la promotion</h2>
                <div className="relative max-w-full overflow-x-auto mb-6 px-4 md:px-0">
                    <PromotionTable promotion={promotion}/>
                </div>
            </div>
        </>
    );
}

export default PromotionDetails;
